import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IntegrationCardView } from '../../models/integration/vendor-definition.model';
import { IPartnerClient } from '../../models/outbound/partner-client.model';
import { PartnerClientProvider } from '../../provider/partner-client.provider';

/**
 * "Outbound API Integration" on Org Settings → Integrations (REV-21638):
 * self-serve Partner-API credentials, rendered as universal integration
 * cards. ORG_ADMIN only — the hosting page already sits behind the AdminGuard.
 */
@Component({
    selector: 'aumico-outbound-api-section',
    templateUrl: './outbound-api-section.component.html',
    styleUrls: ['./outbound-api-section.component.scss'],
})
export class OutboundApiSectionComponent implements OnInit {
    public clients$!: Observable<IPartnerClient[]>;

    public createModalOpen = false;
    public infoClient: IPartnerClient | null = null;

    public constructor(private readonly partnerClientProvider: PartnerClientProvider) {}

    public ngOnInit(): void {
        this.clients$ = this.partnerClientProvider.getClients$();
        this.partnerClientProvider.loadClients();
    }

    public trackByClientId(_index: number, client: IPartnerClient): string {
        return client.id;
    }

    public cardView(client: IPartnerClient): IntegrationCardView {
        return {
            vendor: client.clientId,
            // Verbatim credential name — never an i18next key (see IntegrationCardView).
            displayNameRaw: client.displayName,
            descriptionKey: 'aumico_outbound_api_card_description',
            logoSrc: '/assets/hamIcons/outbound-api-logo.svg',
            bannerBgColor: '#f9fafb',
        };
    }

    public onCreate(): void {
        this.createModalOpen = true;
    }

    public onInfo(client: IPartnerClient): void {
        this.infoClient = client;
    }

    public onModalsClosed(): void {
        this.createModalOpen = false;
        this.infoClient = null;
    }
}
